module.exports = __webpack_public_path__ + "static/media/DemoArrowSecond.2739225e.svg";